import { EcommerceCustomer } from "../features/e-commerce/pages/e-comm-customer"
import { DashboardLayout } from "../layouts/DashboardLayout"

export default function ECommerceCustomerPage() {
  return (
    <DashboardLayout>
      <EcommerceCustomer />
    </DashboardLayout>
  )
}
